import React, { useEffect, useState } from 'react';
import { ArgumentPair, InspectionViewRequest, TxInspection } from '../../../../../../../../types/rest/analyticsTypes';
import FullPageLoader from '../../../../../../../../components/loaders/FullPageLoader';
import { useIsMount } from '../../../../../../../../hooks/useIsMountHook';
import analyticsApi from '../../../../../../../../axios/ac/analyticsApi';
import { showToastNotification } from '../../../../../../../../store/ui/toasts/toastsActions';
import { ToastType } from '../../../../../../../../store/ui/toasts/toastsTypes';
import { useDispatch } from 'react-redux';
import HttpTransactionDslDetail from './HttpTransactionDslDetail';

interface Props {
  httpTransactionRecorded: InspectionViewRequest;
  requestArgs: ArgumentPair[];
}

const HttpTransactionDetail = ({ httpTransactionRecorded, requestArgs }: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dslDetails, setDslDetails] = useState<TxInspection>();
  const isMount = useIsMount();
  const dispatch = useDispatch();

  const getHttpTransaction = async () => {
    try {
      const response = (await analyticsApi.inspectionData.getInspectionData(httpTransactionRecorded.id)).data;
      if (response.result.type === 'TRANSACTIONAL') {
        if (response.result.runnerType !== null && response.result.runnerType === 'HTTP') {
          //mapping response to type TxInspection:
          const requestDetails = {
            runnerType: 'HTTP',
            request: {
              header: response.result.requestHeaders ? response.result.requestHeaders : [],
              bodyContent: response.result.requestBody
                ? Buffer.from(response.result.requestBody, 'base64').toString()
                : null,
            },
            response: {
              header: response.result.responseHeaders ? response.result.responseHeaders : [],
              bodyContent: response.result.responseBody
                ? Buffer.from(response.result.responseBody, 'base64').toString()
                : null,
              resultCode: response.result.statusCode,
            },
          };
          setDslDetails(requestDetails);
        }
      }
    } catch (e) {
      dispatch(showToastNotification(ToastType.Danger, 'Error getting message detail'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isMount) {
      getHttpTransaction();
    }
  }, []);

  return (
    <div className={'p-4'}>
      {isLoading && (
        <FullPageLoader className={'mt-8 mb-8'} loadingText={'Loading transaction request/response detail...'} />
      )}
      {!isLoading && <HttpTransactionDslDetail txDslDetails={dslDetails} requestArgs={requestArgs} />}
    </div>
  );
};

export default HttpTransactionDetail;
